/**
 * @file M36 Person Info Overlay
 *
 * @author christian.sany@notch-interactive.com
 */

// Imports
import overlay from '../components/overlay';
import coverModes from '../modules/cover-modes';
import tabs from '../modules/m20-tabs';

const instance = {};

let overlayInstance;

/**
 * Initiate the module
 */
instance.init = () => {
    overlayInstance = overlay({
        type: 'person-info',
        insertEndOfBody: true
    });

    if (overlayInstance) {
        overlayInstance.on('opened', () => {
            coverModes.refresh();
            tabs.init();
        });
    }
};

/**
 * Destroy the module
 */
instance.destroy = () => {
    try {
        overlayInstance.destroy();
    } catch (e) {
        console.warn(e);
    }
};

export default instance;
